import axios from 'axios'
import store from '@/store'
import {apiUrl} from '@/config/env'

const apicall = axios.create({
    timeout: 15000, // 15s
    headers: {
        "Accept": "application/json,text/plain,*/*",
        "Content-Type": "application/json;charset=utf-8",
        "X-Requested-With": "XMLHttpRequest"
    }
})

// 添加请求拦截器(request)
apicall.interceptors.request.use(function(config) {
    store.dispatch('showloader')
    // console.log(config)

    let data = config['data']
    config['data'] = {
        api: config['url'].replace('^/', ''),
        edatas: data,
        timestamp: Date.parse(new Date()) / 1000,
        version: 'v1.0'
    }
    config['method'] = 'post';
    config['url'] = apiUrl + '/h5.php'
    return config
}, function(err) {
    return Promise.reject(err)
})

// 添加响应拦截器(response)
apicall.interceptors.response.use(function(response) {
    store.dispatch('hideloader')
    // console.log(response)

    let rdata = response['data']
    response['data'] = {
        code: rdata.ErrorCode,
        message: rdata.Message,
        results: rdata.Data.Results ? rdata.Data.Results : rdata.Data,
        pagination: rdata.Data.Pagination
    }
    return response
}, function(err) {
    store.dispatch('hideloader')
    if(err && err.response) {
        err = checkErr(err)
    }
    return Promise.reject(err)
})

const checkErr = err => {
    if(err && err.response)
    {
        switch(err.response.status)
        {
            case 400: err.message = '请求错误'; break
            case 401: err.message = '未授权,请求登录'; break
            case 403: err.message = '拒绝访问'; break
            case 404: err.message = '请求地址出错'; break
            case 408: err.message = '请求超时'; break
            case 500: err.message = '服务器内部错误'; break
            case 501: err.message = '服务未实现'; break
            case 502: err.message = '网关错误'; break
            case 503: err.message = '服务不可用'; break
            case 504: err.message = '网关超时'; break
            case 505: err.message = 'HTTP版本不受支持'; break
            default: 
        }
        return err
    }
}

export default apicall